import { render } from "./match-result.vue?vue&type=template&id=3168726f&scoped=true"
import script from "./match-result.vue?vue&type=script&lang=js"
export * from "./match-result.vue?vue&type=script&lang=js"

import "./match-result.vue?vue&type=style&index=0&id=3168726f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3168726f"]])

export default __exports__